import { t } from "@/lib/i18n";
import { MapPinned, Bot, MessageCircle, BellRing, ArrowRight } from "lucide-react";

const STEPS = [
  { Icon: MapPinned, k: "how.s1" },
  { Icon: Bot, k: "how.s2" },
  { Icon: MessageCircle, k: "how.s3" },
  { Icon: BellRing, k: "how.s4" },
];

export const HowItWorks = ({ onOpenChat, onOpenCases }) => (
  <section id="como-funciona" data-testid="how-it-works" className="mx-auto max-w-[1300px] scroll-mt-16 px-4 py-24 sm:px-8 lg:py-28">
    <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
      <div>
        <p className="ac-eyebrow">{t("how.kicker")}</p>
        <h2 className="mt-5 font-wide text-4xl font-normal leading-[1.05] text-ac-ink sm:text-5xl">{t("how.title")}</h2>
      </div>
      <div className="flex gap-2">
        <button data-testid="how-open-chat" onClick={onOpenChat} className="ac-pill ac-pill-solid">
          {t("how.start")} <ArrowRight className="h-4 w-4" />
        </button>
        <button data-testid="how-open-cases" onClick={onOpenCases} className="ac-pill ac-pill-ghost">
          {t("how.cases")}
        </button>
      </div>
    </div>
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {STEPS.map(({ Icon, k }, i) => (
        <div key={k} className="group relative overflow-hidden rounded-3xl border border-ac-line bg-ac-surface p-7 transition-[transform,box-shadow,border-color] hover:-translate-y-1 hover:border-ac-primary-line hover:shadow-[0_18px_40px_-20px_rgba(0,27,62,0.4)]">
          <span className="absolute right-5 top-4 font-mono text-4xl font-bold text-ac-surface3 transition-colors group-hover:text-ac-primary-line">0{i + 1}</span>
          <span className="ac-grad grid h-11 w-11 place-items-center rounded-full text-white"><Icon className="h-5 w-5" /></span>
          <h3 className="mt-6 font-wide text-xl font-semibold text-ac-ink">{t(`${k}t`)}</h3>
          <p className="mt-1 text-sm text-ac-muted">{t(k)}</p>
        </div>
      ))}
    </div>
  </section>
);
